export default "__VITE_ASSET__Cp$IeVJM__"